import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TOrganizations from './Tables/TOrganizations';
const Organization: React.FC = () => {
    return (
        <div>
            <AdminHeader>Organizaciones</AdminHeader>
            <TOrganizations/>
        </div>

    );
};


export default Organization;